import { z } from "zod";

// 비밀번호 찾기 요청
export const ForgotPasswordRequestSchema = z.object({
  email: z.string().email("유효한 이메일을 입력해주세요"),
  name: z.string().min(1, "이름을 입력해주세요"),
});

export type ForgotPasswordRequest = z.infer<typeof ForgotPasswordRequestSchema>;

// 비밀번호 재설정 요청 (MES: 8-16자, 영문+숫자+특수문자)
export const ResetPasswordRequestSchema = z.object({
  token: z.string().min(1, "토큰이 필요합니다"),
  newPassword: z
    .string()
    .min(8, "비밀번호는 8자 이상이어야 합니다")
    .max(16, "비밀번호는 16자 이하여야 합니다")
    .regex(/[a-zA-Z]/, "영문자를 포함해야 합니다")
    .regex(/[0-9]/, "숫자를 포함해야 합니다")
    .regex(
      /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/,
      "특수문자를 포함해야 합니다"
    ),
});

export type ResetPasswordRequest = z.infer<typeof ResetPasswordRequestSchema>;

// 토큰 검증 응답
export const TokenVerifyResponseSchema = z.object({
  valid: z.boolean(),
  reason: z.string().optional().nullable(),
  maskedEmail: z.string().optional().nullable(),
});

export type TokenVerifyResponse = z.infer<typeof TokenVerifyResponseSchema>;
